import React from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const NotFoundPage: React.FC = () => {
  return (
    <div className="dag-statepage">
      <div className="dag-statepage__card">
        <div className="dag-statepage__icon" aria-hidden="true">
          <MagnifyingGlassIcon className="h-7 w-7" />
        </div>
        <h1 className="dag-statepage__title">This page doesn&rsquo;t exist</h1>
        <p className="dag-statepage__text">
          The page you&rsquo;re looking for was not found or has been moved.
        </p>
        <div className="dag-statepage__actions">
          <Link to="/" className="btn-primary">
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
